import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import GetAppIcon from "@material-ui/icons/GetApp";
import PrintIcon from "@material-ui/icons/Print";
import PDFViewer from "../E_Signature/PDFViewer";

const SonyPdfListPopup = ({ show, setshow, modalData }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        setSelectedIndex(0);
    }, [modalData]);

    if (!show || !modalData) return null;

    const {
        title = "Letter Details",
        employeeName = "",
        employeeCode = "",
        phoneNumber = "",
        pdfList = []
    } = modalData;

    const handleClose = () => {
        setshow(false);
    };

    const currentItem = pdfList[selectedIndex] || pdfList[0] || {};
    const currentPdfUrl = currentItem.pdf || "";

    const getFileName = (url) => {
        if (!url) return "document.pdf";
        try {
            const parts = url.split("/");
            return parts[parts.length - 1] || "document.pdf";
        } catch (e) {
            return "document.pdf";
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "--";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric"
            });
        } catch (e) {
            return "--";
        }
    };

    const formatTime = (dateString) => {
        if (!dateString) return "";
        try {
            const date = new Date(dateString);
            return date.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });
        } catch (e) {
            return "";
        }
    };

    const handleDownload = (url, fileName) => {
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.download = fileName || getFileName(url);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePrint = (url) => {
        if (!url) return;
        const printWindow = window.open(url, "_blank");
        if (printWindow) {
            printWindow.focus();
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 99999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px"
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: "1280px",
                    height: "90%",
                    maxHeight: "850px",
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "0 12px 32px rgba(0, 0, 0, 0.25)"
                }}
            >
                {/* Header */}
                <div
                    style={{
                        padding: "16px 24px",
                        backgroundColor: "#ffffff",
                        borderBottom: "1px solid #eaecf0",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <div>
                        <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#101828" }}>
                            {title} — {employeeName || "Employee"}
                        </h3>
                        <div style={{ fontSize: "13px", color: "#667085", marginTop: "3px" }}>
                            {pdfList.length} letter{pdfList.length !== 1 ? "s" : ""} issued
                            {employeeCode ? ` · ${employeeCode}` : ""}
                            {phoneNumber ? ` · ${phoneNumber}` : ""}
                        </div>
                    </div>
                    <button
                        onClick={handleClose}
                        style={{
                            background: "none",
                            border: "1px solid #d0d5dd",
                            borderRadius: "6px",
                            cursor: "pointer",
                            padding: "6px 8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#667085",
                            transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f2f4f7")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                    >
                        <CloseOutlinedIcon style={{ fontSize: "20px" }} />
                    </button>
                </div>

                {/* Content Body */}
                <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
                    {/* Left Sidebar - List of PDFs */}
                    <div
                        style={{
                            width: "320px",
                            borderRight: "1px solid #eaecf0",
                            backgroundColor: "#ffffff",
                            overflowY: "auto"
                        }}
                    >
                        {pdfList && pdfList.length > 0 ? (
                            pdfList.map((item, idx) => {
                                const isSelected = idx === selectedIndex;
                                const fName = getFileName(item.pdf);
                                const dateStr = formatDate(item.created);
                                const timeStr = formatTime(item.created);

                                return (
                                    <div
                                        key={idx}
                                        onClick={() => setSelectedIndex(idx)}
                                        style={{
                                            padding: "16px 20px",
                                            borderBottom: "1px solid #f2f4f7",
                                            cursor: "pointer",
                                            backgroundColor: isSelected ? "#fff5ee" : "#ffffff",
                                            borderLeft: isSelected ? "4px solid #f26639" : "4px solid transparent",
                                            transition: "background-color 0.2s ease"
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontWeight: 700,
                                                fontSize: "14px",
                                                color: isSelected ? "#d94f00" : "#101828"
                                            }}
                                        >
                                            {item.letterTypeTitle || title}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#667085", marginTop: "4px" }}>
                                            {fName.length > 24 ? `${fName.slice(0, 22)}...` : fName} · {dateStr}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#98a2b3", marginTop: "2px" }}>
                                            Created {dateStr} {timeStr ? `at ${timeStr}` : ""}
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div style={{ padding: "24px", color: "#667085", textAlign: "center", fontSize: "14px" }}>
                                No letters available
                            </div>
                        )}
                    </div>

                    {/* Right PDF Preview Area */}
                    <div
                        style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#323639"
                        }}
                    >
                        {/* PDF Toolbar */}
                        <div
                            style={{
                                height: "48px",
                                backgroundColor: "#2b2b2e",
                                padding: "0 20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #1e1e21",
                                color: "#ffffff"
                            }}
                        >
                            <span
                                style={{
                                    fontSize: "13px",
                                    color: "#e0e0e0",
                                    fontFamily: "monospace",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "450px"
                                }}
                                title={getFileName(currentPdfUrl)}
                            >
                                {getFileName(currentPdfUrl)}
                            </span>

                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <button
                                    onClick={() => handlePrint(currentPdfUrl)}
                                    style={{
                                        background: "#3e3e42",
                                        border: "1px solid #525257",
                                        borderRadius: "4px",
                                        color: "#ffffff",
                                        padding: "5px 12px",
                                        fontSize: "13px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}
                                >
                                    <PrintIcon style={{ fontSize: "16px" }} /> Print
                                </button>

                                <button
                                    onClick={() => handleDownload(currentPdfUrl, getFileName(currentPdfUrl))}
                                    style={{
                                        background: "#f26639",
                                        border: "none",
                                        borderRadius: "6px",
                                        color: "#ffffff",
                                        padding: "6px 16px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                    }}
                                >
                                    <GetAppIcon style={{ fontSize: "16px" }} /> Download PDF
                                </button>
                            </div>
                        </div>

                        {/* PDF Display Container */}
                        <div
                            style={{
                                flex: 1,
                                backgroundColor: "#525659",
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            {currentPdfUrl ? (
                                <PDFViewer pdfUrl={currentPdfUrl} />
                            ) : (
                                <div style={{ color: "#ffffff", fontSize: "15px", margin: "auto" }}>No PDF selected</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SonyPdfListPopup;
